import {
    CompositeModel,
    TextModel,
    RadioModel,
    DisplayDecorator,
    CustomInjector,
    TextModelOptions,
    UserGidService,
    MultilineTextModel,
    MultilineTextModelOptions,
    NotificationIdentifier,
    IncidentType,
} from '@evorait/pace-core';
import { TranslateService } from '@ngx-translate/core';
import { FormState } from '../../store/state/form.state';

export class DocumentFeedbackModel extends CompositeModel {
    public gid: TextModel;
    public feedback_description: MultilineTextModel;
    public section_number: TextModel;
    public form_id: TextModel;
    public category: RadioModel<TextModel>;
    public notification: NotificationIdentifier;
    public productKey: string;
    public doctypeKey: string;
    public modality: string;
    public defaultInfoclass: string;
    public variant: string;
    public version: string;
    public language: string;

    public constructor(form: FormState) {
        super('DocumentFeedbackModel');
        const injector = CustomInjector.getInjector();
        const translate = injector.get(TranslateService);
        const userGidService = injector.get(UserGidService);

        this.feedback_description = new MultilineTextModel(
            'feedback_description',
            '',
            new MultilineTextModelOptions({ required: true }),
        );

        this.section_number = new TextModel('section_number', '', new TextModelOptions({ required: true }));

        const categoryOptions: Array<DisplayDecorator<TextModel>> = [];
        categoryOptions.push(
            new DisplayDecorator(
                <string>translate.instant('DOCUMENT_FEEDBACK_OPTION_FAILURE'),
                new TextModel(IncidentType.FAILURE, IncidentType.FAILURE),
            ),
        );
        categoryOptions.push(
            new DisplayDecorator(
                <string>translate.instant('DOCUMENT_FEEDBACK_OPTION_REQUEST'),
                new TextModel(IncidentType.REQUEST, IncidentType.REQUEST),
            ),
        );

        this.category = new RadioModel<TextModel>('category', categoryOptions);

        const gid = userGidService.getUserGid();
        const isGidReadonly = typeof gid !== 'undefined' && gid !== '';
        this.gid = new TextModel(
            'gid',
            gid,
            new TextModelOptions({ required: true, minLength: 8, maxLength: 8, readonly: isGidReadonly }),
        );

        this.form_id = new TextModel('form_id', form.formId.formId, new TextModelOptions({ readonly: true }));
        this.productKey = form.orgData.productKey;
        this.doctypeKey = form.orgData.doctypeKey;
        this.modality = form.orgData.modality;
        this.defaultInfoclass = form.orgData.defaultInfoClass;
        this.notification = form.notification;
        this.version = form.orgData.version;
        this.language = form.language;
        this.variant = form.variant;
    }

    public getGID(): string {
        return this.gid.value.toUpperCase();
    }
}
